import CommitteeType from '../consts/CommitteeType';

export default class ElectionInfoRequiredUtil {

    public static electionDateRequiredCommitteeTypeCodes = [
        CommitteeType.SCHOOL_BOARD_CANDIDATE,
        CommitteeType.CITY_CANDIDATE__MAYOR,
        CommitteeType.CITY_CANDIDATE__CITY_COUNCIL,
        CommitteeType.CITY_CANDIDATE__OTHER,
        CommitteeType.LOCAL_BALLOT_ISSUE,
        CommitteeType.SCHOOL_BOARD_OR_OTHER_POLITICAL_SUBDIVISION_PAC,
        CommitteeType.OTHER_POLITICAL_SUBDIVISION_CANDIDATE,
        CommitteeType.STATE_HOUSE,
        CommitteeType.STATE_SENATE,
        CommitteeType.ATTORNEY_GENERAL,
        CommitteeType.AUDITOR_OF_STATE,
        CommitteeType.GOVERNOR,
        CommitteeType.LT_GOVERNOR,
        CommitteeType.TREASURER_OF_STATE,
        CommitteeType.SECRETARY_OF_STATE,
        CommitteeType.SECRETARY_OF_AGRICULTURE,
        CommitteeType.JUDGE_STANDING_FOR_RETENTION
    ];


    public static electionDateRequired(typeCode?: string) {
        if (!!typeCode && this.electionDateRequiredCommitteeTypeCodes.indexOf(typeCode) >= 0) {
            return true;
        }
        return false;
    }

    public static swgaCommitteeTypeCodes = [
        CommitteeType.STATE_HOUSE,
        CommitteeType.STATE_SENATE,
        CommitteeType.ATTORNEY_GENERAL,
        CommitteeType.AUDITOR_OF_STATE,
        CommitteeType.GOVERNOR,
        CommitteeType.LT_GOVERNOR,
        CommitteeType.SECRETARY_OF_STATE,
        CommitteeType.SECRETARY_OF_AGRICULTURE,
        CommitteeType.TREASURER_OF_STATE,
        CommitteeType.JUDGE_STANDING_FOR_RETENTION
    ];

    public static isSWGACommitteeType(typeCode?: string) {
        if ( !!typeCode && this.swgaCommitteeTypeCodes.indexOf(typeCode) >= 0) {
            return true;
        }
        return false;
    }

    public static getElectionYears() {
        const electionYears: number[] = [];
        // TODO: Maybe this should be something like current year +- 10 years rather than starting from 1995?
        for (let i = (new Date()).getFullYear() + 10; i > 1995; i--) {
            electionYears.push(i);
        }

        return electionYears;
    }

}
